import React, { useContext } from 'react';
import AppContext from './AppContext';
import { beautifyPokemonName, TYPES_TO_COLORS } from './helper';
import PokedexSprite from './PokedexClickedPokemonSprite';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from './components/Card';

function PokedexNameAndType() {
  const {
    dex,
    GenusFlavorText,
    clickedSpeciesId,
  } = useContext(AppContext);
  if (clickedSpeciesId == null) {
    return (
      <div>
        No data.
      </div>
    );
  }

  const { name, types, baseSpecies } = dex[clickedSpeciesId];
  const baseSpeciesId = baseSpecies?.toLocaleLowerCase().replace('-', '');
  const { genus } = GenusFlavorText[clickedSpeciesId] || GenusFlavorText[baseSpeciesId || ''] || {};
  const genusComponent = (
    <span className="block text-xs">
      {genus}
    </span>
  );

  const [type1, type2] = types;
  const type1P = <p style={{ color: `rgb(${TYPES_TO_COLORS[type1].join(',')})` }}>{type1}</p>;
  const type2P = type2 === undefined
    ? null
    : <p style={{ color: `rgb(${TYPES_TO_COLORS[type2].join(',')})` }}>{type2}</p>;
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-bold">{beautifyPokemonName(name)}</CardTitle>
        <CardDescription>
          {
            genus == null || genus === undefined
              ? null
              : genusComponent
          }
          <span className="inline-flex text-sm font-bold">
            {type1P}
            &nbsp;
            {type2P}
          </span>
        </CardDescription>
        <CardContent className="block my-1 flex justify-center">
          <PokedexSprite />
        </CardContent>
      </CardHeader>
    </Card>
  );
}

export default PokedexNameAndType;
